import { IsAllow } from './portfolio';

export const SIGNUP = 'SIGNUP';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';

export const VERIFY_OTP = 'VERIFY_OTP';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';

export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_PASSWORD_SUCCESS = 'SET_PASSWORD_SUCCESS';

export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const RESEND_LOGIN_OTP = 'RESEND_LOGIN_OTP';
export const RESEND_LOGIN_OTP_SUCCESS = 'RESEND_LOGIN_OTP_SUCCESS';

export const VALIDATE_SECRET_ANSWER = 'VALIDATE_SECRET_ANSWER';
export const VALIDATE_SECRET_ANSWER_SUCCESS = 'VALIDATE_SECRET_ANSWER_SUCCESS';

export const SAVE_SECRET_QUESTIONS = 'SAVE_SECRET_QUESTIONS';
export const SAVE_SECRET_QUESTIONS_SUCCESS = 'SAVE_SECRET_QUESTIONS_SUCCESS';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';

export const VERIFY_FORGOT_PASSWORD = 'VERIFY_FORGOT_PASSWORD';
export const VERIFY_FORGOT_PASSWORD_SUCCESS = 'VERIFY_FORGOT_PASSWORD_SUCCESS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const SET_MF_NEW = 'SET_MF_NEW';

export const READ_NOTIFICATIONS = 'READ_NOTIFICATIONS';
export const READ_NOTIFICATIONS_SUCCESS = 'READ_NOTIFICATIONS_SUCCESS';

export const REDIRECT_ACTION = 'REDIRECT_ACTION';
export const SET_IS_FROM_PRE_LOGIN = 'SET_IS_FROM_PRE_LOGIN';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';

export const UPDATE_FIRST_TIME_SETTINGS = 'UPDATE_FIRST_TIME_SETTINGS';
export const MOBILE_SESSION_OUT = 'MOBILE_SESSION_OUT';
export const MOBILE_SESSION_FORCE_LOGOUT = 'MOBILE_SESSION_FORCE_LOGOUT';

export const FORGOT_QUESTION_ANSWER_OTP_SUCCESS = 'FORGOT_QUESTION_ANSWER_OTP_SUCCESS';
export const FORGOT_QA = 'FORGOT_QA';

export const CLEAR_POPUP_STATUS = "CLEAR_POPUP_STATUS";

export interface SignupPayload {
    pan?: string;
    pekrn?: string;
    mobile?: string;
    email?: string;
    action?: string;
}

export interface SignupResponse {
    reqId: string;
    otpRef: string;
    otp: string;
}

export interface VerifyOtpPayload {
    otpRef: string;
    reqId: string;
    enteredOtp: string;
    pan?: string;
    pekrn?: string;
    mobile?: string;
    action: string;
    token?: string;
}

export interface SetPasswordPayload {
    otpRef: string;
    reqId: string;
    password: string;
    displayName: string;
    action: string;
}
export interface LoginPayload {
    pan?: string;
    pekrn?: string;
    password: string;
    userId?: string;
    captcha?: string | null;
}

export type PasswordChange = {
    pan?: string;
    pekrn?: string;
    newPassword: string;
    action?: string;
};
export interface ChangePasswordPayload extends PasswordChange {
    currentPassword: string;
    mobile: string;
}
export interface ForgotPasswordPayload extends PasswordChange {
    action: string;
    userId: string;
}
export interface verifyQuestionnaire {
    pan: string;
    pekrn: string;
    reqId: string;
    action: string;
    data: Array<QUESTION_PROPS>;
}

export interface QUESTION_PROPS {
    questionTypeId: string;
    secretAnswer: string;
}

export enum RegisterWith {
    Mobile = 'MOBILE',
    Email = 'EMAIL',
}

export interface AuthState {
    token: string | null;
    notificationCount: number;
    redirectPath: string | null;
    isLoggedOut: boolean;
    isLoggedIn: boolean;
    enableTwoFactorAuth: boolean;
    firstTimeLoggedIn: boolean;
    displayName: string;
    userRegisteredWith: string;
    email: string;
    appTourVisited: boolean;
    enabledPin: boolean;
    backupPin: string;
    skipDeviceAuth: boolean;
    initialSettingsAsked: boolean;
    isAutheticatedByDeviceOrPin: boolean;
    pan: string;
    pekrn: string;
    mobile: string;
    manualLogout?: boolean;
    isFromPreLogin?: boolean;
    showPopUp?: IsAllow;
    message?: string;
    ftTransactions?: IsAllow | undefined;
    newToMF: string | undefined;
}

export type LOGIN_OTP_VERIFY_PAYLOAD = {
    userId: string;
    reqId: string;
    otpRef: string;
    enteredOtp: string;
    action?: 'OTP_LOGIN';
};

export type LOGIN_OTP_GENERATE_PAYLOAD = {
    userId: string;
    action?: 'OTP_LOGIN';
};

export type LOGIN_RESEND_OTP = {
    action?: 'OTP_LOGIN' | 'PRELOGIN_TRANSMISSION' | string;
    reqId: string;
    otpRef: string;
};
export interface NotificationPayload extends SignupPayload {
    reqId: string;
}

export type ReadNotificationInfo = {
    notificationId: string;
    readStatus: 'Y' | 'N';
};
export interface ReadNotificationPayload extends NotificationPayload {
    notifications: ReadNotificationInfo[];
}

export type NotificationInfo = {
    notificationId: string;
    reqId: string;
    amc: string;
    amcName: string;
    folio: string;
    status: string;
    requestType: string;
    requestTypeDesc: string;
    timestamp: string;
};
interface onSignUp {
    type: typeof SIGNUP_SUCCESS;
    isTimeout?: boolean;
    body: SignupPayload;
}

export type ForgotPasswordOtpVerify = {
    enteredOtp: string;
    userId: string;
    action: ACTION;
    reqId: string;
    otpRef: string;
};

type ACTION = 'FORGOT_PWD';

export interface OTP_RESPONSE extends SignupResponse { }

export type AuthTypes = onSignUp;
